import { render, staticRenderFns } from "./posterInformations.vue?vue&type=template&id=42fc5032"
import script from "./posterInformations.vue?vue&type=script&lang=js"
export * from "./posterInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports